export default "__VITE_PUBLIC_ASSET__95bd6fbd__"